export default __webpack_public_path__ + "static/media/movie_black_24dp.0bbb8f9d.svg";